<template>
    <div class="fff p10 edit">
      <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="handleChangeDrawer">
        <div slot="body">
          <div class="pay-mains">
            <p class="order-title-boxs"><span class="blueBlock"></span><i>店员信息</i></p>
            <div class="totals-box plr24 mt30">
              <div class="flex-row mb30">
                <div class="itemName">审核状态</div>
                <div class="itemNum" :class="form.auditStatus == 'refuse' ? 'moneys':form.auditStatus == 'pass' ? 'jishi' : ''">{{ form.auditStatusCn }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName" :class="{'isUpdate': form.applyItemMap.headImgUrl.updateFlag}">头像</div>
                <div class="img-list" v-if="form.applyItemMap.headImgUrl.newValue">
                  <el-image
                    class="img"
                    :src="form.applyItemMap.headImgUrl.newValue"
                    title="点击放大图片"
                    :preview-src-list="[form.applyItemMap.headImgUrl.newValue]"
                  ></el-image>
                </div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName" :class="{'isUpdate': form.applyItemMap.staffName.updateFlag}">姓名</div>
                <div class="itemNum">{{ form.applyItemMap.staffName.newValue }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName" :class="{'isUpdate': form.applyItemMap.mobile.updateFlag}">手机号</div>
                <div class="itemNum">{{ form.applyItemMap.mobile.newValue }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName" :class="{'isUpdate': form.applyItemMap.positionId.updateFlag}">职位</div>
                <div class="itemNum">{{ form.applyItemMap.positionId.newValue }}</div>
              </div>
              <div class="flex-row mb30">
                <div class="itemName" :class="{'isUpdate': form.applyItemMap.roleIds.updateFlag}">关联角色</div>
                <div class="itemNum">{{ form.applyItemMap.roleIds.newValue }}</div>
              </div>

              <template v-if="userInfo.shopBizConfig.yuanyuanFlag">
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.urgentContactName.updateFlag}">紧急联系人</div>
                  <div class="itemNum">{{ form.applyItemMap.urgentContactName.newValue }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.urgentContactMobile.updateFlag}">手机号码</div>
                  <div class="itemNum">{{ form.applyItemMap.urgentContactMobile.newValue }}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.relationWithMe.updateFlag}">与本人关系</div>
                  <div class="itemNum">{{ form.applyItemMap.relationWithMe.newValue }}</div>
                </div>
              </template>

              <template v-if="userInfo.shopBizConfig.yuanyuanFlag || form.isGroupShopFlag">
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.bankCardAccountType.updateFlag}">账户类型</div>
                  <div class="itemNum">{{form.applyItemMap.bankCardAccountType.newValue == 'myAccount' ? '本人账户':'他人账户'}}</div>
                </div>
                <div class="flex-row mb30" v-if="form.applyItemMap.bankCardAccountType.newValue == 'otherAccount'">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.agentStaffName.updateFlag}">委托人</div>
                  <div class="itemNum">{{form.applyItemMap.agentStaffName.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.bankName.updateFlag}">银行名称</div>
                  <div class="itemNum">{{form.applyItemMap.bankName.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.subBankName.updateFlag}">开户行</div>
                  <div class="itemNum">{{form.applyItemMap.subBankName.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.bankCardNo.updateFlag}">银行卡号</div>
                  <div class="itemNum">{{form.applyItemMap.bankCardNo.newValue}}</div>
                </div>
                <div class="flex-row mb30" v-if="userInfo.shopBizConfig.yuanyuanFlag">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.bankNo.updateFlag}">联行号</div>
                  <div class="itemNum">{{form.applyItemMap.bankNo.newValue}}</div>
                </div>
                <div class="flex-row mb30" v-if="userInfo.shopBizConfig.yuanyuanFlag">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.bankNoImg.updateFlag}">联行号查询截图</div>
                  <div class="itemNum">
                    <div class="img-list" v-if="form.applyItemMap.bankNoImg.newValue">
                      <el-image
                        style="width: 100px; height: 100px;"
                        :src="form.applyItemMap.bankNoImg.newValue"
                        title="点击放大图片"
                        :preview-src-list="[form.applyItemMap.bankNoImg.newValue]"
                      ></el-image>
                    </div>
                  </div>
                </div>
                <div class="flex-row mb30" v-if="userInfo.shopBizConfig.yuanyuanFlag">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.bankMobile.updateFlag}">银行预留手机号</div>
                  <div class="itemNum">{{form.applyItemMap.bankMobile.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.idCardNo.updateFlag}">身份证号码</div>
                  <div class="itemNum">{{form.applyItemMap.idCardNo.newValue}}</div>
                </div>
                <div class="flex-row mb30" v-if="userInfo.shopBizConfig.yuanyuanFlag">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.idCardValidEndTime.updateFlag}">证件到期时间</div>
                  <div class="itemNum">{{form.applyItemMap.idCardValidEndTime.newValue}}</div>
                </div>

                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.idCardValidEndTime.updateFlag}">身份证正面</div>
                  <div class="itemNum">
                    <el-image
                      style="width: 220px; height: 140px"
                      :src="form.applyItemMap.idCardFrontUrl.newValue"
                      :preview-src-list="[form.applyItemMap.idCardFrontUrl.newValue]"
                    >
                    </el-image>
                  </div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.idCardValidEndTime.updateFlag}">身份证反面</div>
                  <div class="itemNum">
                    <el-image
                      style="width: 220px; height: 140px"
                      :src="form.applyItemMap.idCardBackUrl.newValue"
                      :preview-src-list="[form.applyItemMap.idCardBackUrl.newValue]"
                    >
                    </el-image>
                  </div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.idCardValidEndTime.updateFlag}">银行卡/委托书</div>
                  <div class="itemNum">
                    <el-image
                    style="width: 220px; height: 140px"
                    :src="form.applyItemMap.bankCardUrl.newValue"
                    :preview-src-list="[form.applyItemMap.bankCardUrl.newValue]"
                    v-if="form.applyItemMap.bankCardAccountType.newValue == 'myAccount'"
                  >
                  </el-image>
                  <el-image
                    style="width: 220px; height: 140px"
                    :src="form.applyItemMap.agentBookUrl.newValue"
                    :preview-src-list="[form.applyItemMap.agentBookUrl.newValue]"
                    v-if="form.applyItemMap.bankCardAccountType.newValue == 'otherAccount'"
                  >
                  </el-image>
                  </div>
                </div>
                <div class="flex-row mb30" v-if="form.applyItemMap.bankCardAccountType.newValue == 'otherAccount'">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.idCardValidEndTime.updateFlag}">手持委托书</div>
                  <div class="itemNum">
                    <el-image
                      style="width: 220px; height: 140px"
                      :src="form.applyItemMap.handImgUrl.newValue"
                      :preview-src-list="[form.applyItemMap.handImgUrl.newValue]"
                      v-if="form.applyItemMap.handImgUrl.newValue"
                    >
                    </el-image>
                  </div>
                </div>

                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.politicalAffiliation.updateFlag}">政治面貌</div>
                  <div class="itemNum">{{form.applyItemMap.politicalAffiliation.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.maritalStatus.updateFlag}">婚姻状况</div>
                  <div class="itemNum">{{form.applyItemMap.maritalStatus.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.idCardAddress.updateFlag}">身份证住址</div>
                  <div class="itemNum">{{form.applyItemMap.idCardAddress.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.accommodationType.updateFlag}">住宿方式</div>
                  <div class="itemNum">{{form.applyItemMap.accommodationType.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.height.updateFlag}">身高</div>
                  <div class="itemNum">{{form.applyItemMap.height.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.weight.updateFlag}">体重</div>
                  <div class="itemNum">{{form.applyItemMap.weight.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.degreeOfEducation.updateFlag}">文化程度</div>
                  <div class="itemNum">{{form.applyItemMap.degreeOfEducation.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.graduatedSchool.updateFlag}">毕业院校</div>
                  <div class="itemNum">{{form.applyItemMap.graduatedSchool.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.professional.updateFlag}">专业</div>
                  <div class="itemNum">{{form.applyItemMap.professional.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.healthCertificateHandleTime.updateFlag}">健康证办理时间</div>
                  <div class="itemNum">{{form.applyItemMap.healthCertificateHandleTime.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.healthTime.updateFlag}">体检时间</div>
                  <div class="itemNum">{{form.applyItemMap.healthTime.newValue}}</div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.healthCertificateImgUrl.updateFlag}">健康证</div>
                  <div class="itemNum">
                    <el-image
                      style="width: 220px; height: 140px"
                      :src="form.applyItemMap.healthCertificateImgUrl.newValue"
                      :preview-src-list="[form.applyItemMap.healthCertificateImgUrl.newValue]"
                      v-if="form.applyItemMap.healthCertificateImgUrl.newValue"
                    >
                    </el-image>
                  </div>
                </div>
                <div class="flex-row mb30">
                  <div class="itemName" :class="{'isUpdate': form.applyItemMap.healthImgUrlList.updateFlag}">体检报告</div>
                  <div class="itemNum">
                    <el-image
                      style="width: 220px; height: 140px"
                      :src="form.applyItemMap.healthImgUrlList.newValue[0]"
                      :preview-src-list="form.applyItemMap.healthImgUrlList.newValue"
                      v-if="form.applyItemMap.healthImgUrls.newValue"
                    >
                    </el-image>
                  </div>
                </div>
              </template>
              <div class="flex-row mb30">
                <div class="itemName">备注</div>
                <div class="itemNum">{{ form.applyRemark }}</div>
              </div>
            </div>
            
            <div class="mb20" v-if="form.showAuditRecordFlag">
                <p class="order-title-boxs"><span class="blueBlock"></span><i>审核流程</i></p>
                <div class="flex-row mlr24" v-for="item,index in auditList" :key="index">
                  <div class="process-left">
                    <div class="process-boxs">
                      <div class="process-img">
                        <img :src="item.headImgUrl" alt="" v-if="item.headImgUrl">
                        <img :src="headImg" alt="" v-else>
                        <div class="audit-img">
                          <img src="../../../assets/images/audit_success.png" alt="" v-if="item.auditStatus == 'pass'">
                          <img src="../../../assets/images/audit_wait.png" alt="" v-else-if="item.auditStatus == 'wait'">
                          <img src="../../../assets/images/audit_refuse.png" alt="" v-else-if="item.auditStatus == 'refuse'">
                        </div>
                      </div>
                      <div class="process-vertical" v-if="auditList.length - index != 1"></div>
                    </div>
                  </div>
                  <div class="ml16 w100b process-right">
                    <div class="align-items color999 f12">
                      <div>{{item.flowNodeName}}</div>
                      <div>{{item.auditTimeFormart}}</div>
                      <!-- <div>{{formatDate(item.auditTime)}}</div> -->
                    </div>
                    <div class="mt5 f16" :class="[auditList.length - index != 1 ? 'mb40':'mb10']">{{item.auditOpName}}<span v-if="item.auditStatus">（{{item.auditStatusDesc}}）</span></div>
                    <div class="process-refuse" v-if="item.auditStatus == 'refuse'">{{item.auditRemark}}</div>
                  </div>
                </div>
            </div>

          </div>
          <div class="drawer-footer pb10 pr24">
            <div class="btns">
              <el-button @click="back">返回</el-button>
            </div>
          </div>
        </div>
      </drawer>
    </div>
  </template>
  
  <script>
  import minxin from "../../../assets/javascript/minxin.js";
  import drawer from "../../../components/common/drawer";
  export default {
    data() {
      return {
        addEditTitle: "修改详情",
        addEditShow: false,
        auditList: [],
        form: {
          applyItemMap: {
            headImgUrl: {},
						accountName: {},
						positionId: {},
            bankCardAccountType: {},
            bankNo: {},
						bankName: {},
						subBankName: {},
						bankCardNo: {},
						idCardFrontUrl: {},
						idCardBackUrl: {},
						agentBookUrl: {},
						bankCardUrl: {},
            roleNames: {},
            idCardValidEndTime: {},
            idCardNo: {},
            bankMobile: {},
            staffName: {},
            mobile: {},
            roleIds: {},
            urgentContactName: {},
            urgentContactMobile: {},
            urgentContactRelation: {},
            handImgUrl: {},
            relationWithMe: {},
            bankCardAccountTypeCn: {},

            politicalAffiliation: {},
            maritalStatus: {},
            accommodationType: {},
            idCardAddress: {},
            height: {},
            weight: {},
            degreeOfEducation: {},
            graduatedSchool: {},
            professional: {},
            healthCertificateHandleTime: {},
            healthTime: {},
            healthCertificateImgUrl: {},
            healthImgUrlList: {},
          }
        },
        title: '确定拒绝吗？',
        headImg: require("../../../assets/images/headerImg.png"),
        userInfo: {
          shopBizConfig: {

          }
        },
      };
    },
    mixins: [minxin],
    created() {
      this.init();
    },
    components: { drawer },
    methods: {
      back() {
        this.addEditShow = false;
      },
      init() {
        this.$on("set", function(row) {
          Object.assign(this.$data, this.$options.data());
          this.userInfo = this.$store.getters.ShopInfo;
          this.form = {
            applyItemMap: {
              headImgUrl: {},
              accountName: {},
              positionId: {},
              bankCardAccountType: {},
              bankNo: {},
              bankName: {},
              subBankName: {},
              bankCardNo: {},
              idCardFrontUrl: {},
              idCardBackUrl: {},
              agentBookUrl: {},
              bankCardUrl: {},
              roleNames: {},
              idCardValidEndTime: {},
              idCardNo: {},
              bankMobile: {},
              staffName: {},
              mobile: {},
              roleIds: {},
              urgentContactName: {},
              urgentContactMobile: {},
              urgentContactRelation: {},
              handImgUrl: {},
              relationWithMe: {},
              bankCardAccountTypeCn: {},

              politicalAffiliation: {},
              maritalStatus: {},
              accommodationType: {},
              idCardAddress: {},
              height: {},
              weight: {},
              degreeOfEducation: {},
              graduatedSchool: {},
              professional: {},
              healthCertificateHandleTime: {},
              healthTime: {},
              healthCertificateImgUrl: {},
              healthImgUrlList: {},
            }
          };
          this.addEditShow = true;
          this.$api.get(this.$url.companyStaffUpdate.get, {
              id: row.id
            })
            .then(res => {
              if (res) {
                this.form = res;
                this.auditList = res.flowAuditRecordMapList;
                if (res.applyItemMap.healthImgUrlList.newValue) {
                  this.form.applyItemMap.healthImgUrlList.newValue = res.applyItemMap.healthImgUrlList.newValue.split(',');
                }
              }
            })
            .catch(error => {});
        });
      },
      handleChangeDrawer() {
        this.addEditShow = false;
        this.$emit("change", false);
      }
    }
  };
  </script>
  
  
  <style scoped lang="less">
  @import "../../../assets/css/edit.less";
  .pay-mains {
    .img {
      border-radius: 20px;
      // margin: 10px 10px 0 0;
      width: 40px;
      height: 40px;
    }
  }

  .isUpdate {
    color: #FF5219 !important;
  }

    .process-boxs {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .process-img {
        width: 40px;
        height: 40px;
        position: relative;
        background-color: #E8E8E8;
        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
    }
    .audit-img {
        width: 14px;
        height: 14px;
        position: absolute;
        right: 0;
        bottom: 0;
            img {
            width: 100%;
            height: 100%;
        }
    }
    .process-vertical {
        width: 2px;
        height: 32px;
        margin: 4px 0;
        background: #E6E6E6;
    }
    .process-right {
        .process-refuse {
            padding: 12px;
            margin-top: 8px;
            color: #666;
            background: #F2F1F6;
            border-radius: 4px;
        }
    }

  </style>